import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

type InternalSummaryProps = {
    internalOrderId?: string;
    panNumber?: string;
    panNumberDescription?: string;
};
const InternalSummary: FC<InternalSummaryProps> = ({ internalOrderId, panNumber, panNumberDescription }) => {
    const { t: translate } = useTranslation(['common', 'orders']);

    return (
        <Fragment>
            {internalOrderId ? (
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:INTERNAL_ORDER_ID')}:</Typography>
                    </Box>
                    <Box>{internalOrderId}</Box>
                </Box>
            ) : undefined}
            {panNumber ? (
                <Box display="flex" mt={1}>
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:PAN_NUMBER')}:</Typography>
                    </Box>
                    <Box>
                        <Box>{panNumber}</Box>
                        {panNumberDescription ? (
                            <Typography variant="body2" color="text.secondary">
                                {panNumberDescription}
                            </Typography>
                        ) : undefined}
                    </Box>
                </Box>
            ) : undefined}
        </Fragment>
    );
};

export default InternalSummary;
